/* eslint id-length: "off", max-statements: ["error", 25] */
const NOT_FOUND = -1;
export const KNOWN_SOURCES = ["am", "bc", "dz", "sp", "ti", "ia", "md"];
export const COMPOUND_SOURCES = ["am", "bc"];

export const SOURCE_LABELS = {
  am: "Apple Music",
  bc: "Bandcamp",
  dz: "Deezer",
  sp: "Spotify",
  ti: "Tidal",
  ia: "Internet Archive",
  md: "Maga Discoteka",
};

const parseEntry = (entry, defaultSource) => {
  const slashIdx = entry.indexOf("/");
  let source = null;
  let idPart = null;

  if (slashIdx === NOT_FOUND) {
    if (!defaultSource) {
      console.warn(`[MusicWrapper] no source prefix in "${entry}"`);
      return null;
    }
    source = defaultSource;
    idPart = entry;
  } else {
    source = entry.slice(0, slashIdx);
    idPart = entry.slice(slashIdx + 1);
  }

  if (!KNOWN_SOURCES.includes(source)) {
    console.warn(`[MusicWrapper] unknown source "${source}" in "${entry}"`);
    return null;
  }

  if (COMPOUND_SOURCES.includes(source)) {
    const [albumId, trackId] = idPart.split(":");
    if (!albumId || !trackId) {
      console.warn(`[MusicWrapper] expected album:track for ${source}, got "${idPart}"`);
      return null;
    }
    return {source, albumId, trackId, raw: entry};
  }

  return {source, trackId: idPart, raw: entry};
};

export const parseTrackList = (raw, opts = {}) => {
  const {defaultSource = null} = opts;
  if (!raw) {
    return [];
  }
  return raw
    .split(",")
    .map(part => part.trim())
    .filter(Boolean)
    .map(entry => parseEntry(entry, defaultSource))
    .filter(Boolean);
};

export const mergeTrackLists = (...lists) => lists.flatMap(list => list ?? []);
